module.exports = __webpack_public_path__ + "static/media/iconProjectsActive.d58a558c.svg";